import * as React from "react";


import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBSwitchOptions} from "./FBSwitch.options";

export class FBSwitchModel extends FBFieldWithPriceBaseModel<FBSwitchOptions,FBColumnModel>
{
    public Checked:boolean;


    constructor(Options: FBSwitchOptions, Parent: FBColumnModel) {
        super(Options, Parent);
    }

    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.Value=this.GetValue();
    }



    GetStoresInformation(): boolean {
        return true;
    }

    GetIsUsed()
    {
        if(!super.GetIsUsed())
            return false;
        return this.Checked;
    }

    GetValue() {
        if(!this.GetIsVisible())
            return false;
        return this.Checked;
    }

    InitializeStartingValues() {
        this.Checked=this.GetPreviousDataProperty('Value', this.Options.Checked);
        this.Quantity=this.GetPreviousDataProperty( 'Quantity',this.Options.QuantityDefaultValue==''?"": this.ParseNumber(this.Options.QuantityDefaultValue));
    }


    GetDynamicFieldNames(): string[] {
        return ['FBSwitch'];
    }
}